import {Collapse, Dropdown, Offcanvas} from 'bootstrap';
import {docReady} from './components/theme/events';
//import {heroSlider, syncMultipleSliders, slider, product_main_slider} from './components/flickity/flickity.entrypoint';
import miniLightbox from './components/theme/mini-lightbox';
import thisYear from './components/theme/this-year';
import isScrolled from './components/theme/is-scrolled';
import scrollToItem from './components/theme/scroll-to-item';
import inView from './components/theme/in-view';
import makeBgImage from './components/theme/make-bg-image';
import markExternalLinks from './components/theme/external-lnks';
import wpAccordion from './components/theme/accordion';
import fixedNavBodyPadding from './components/theme/fixed-nav-body-padding';
import {toggleActive} from './components/theme/toggle';

docReady(() => {
   miniLightbox();
   //fixedNavBodyPadding();
   thisYear();
   isScrolled();
   scrollToItem();
   inView();
   makeBgImage();
   markExternalLinks();
   wpAccordion();
   //slider();
   //heroSlider();
   //product_main_slider();
   //syncMultipleSliders();
   toggleActive();
})
